import { useTeamTimeline } from "@/lib/teamRecordQueries";

const KIND_LABELS = {
  session_booked: "Session", session_cancelled: "Session", assignment_created: "Practice", journey_published: "Journey",
};

/**
 * Clients Restructure — Team 360 -> Timeline. Read-only, Team-owned
 * history only (sessions/assignments/Journey publishes with
 * owner_member_id=null) — never a member's private history.
 */
export default function TimelineTab({ workspaceId }) {
  const { data, isPending, isError } = useTeamTimeline(workspaceId);
  const items = data?.items || [];

  return (
    <div data-testid="team-360-timeline-tab">
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="team-timeline-loading">Loading timeline…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="team-timeline-error">Couldn't load the team timeline.</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-ink-soft" data-testid="team-timeline-empty">No team history yet.</p>
      ) : (
        <ol className="space-y-2 border-l border-ink/10 pl-4" data-testid="team-timeline-list">
          {items.map((e, i) => (
            <li key={i} className="text-sm" data-testid={`team-timeline-event-${i}`}>
              <span className="text-[10px] uppercase text-ink-soft border border-ink/10 rounded-full px-2 py-0.5 mr-2">{KIND_LABELS[e.kind] || e.kind}</span>
              <span className="text-ink">{e.label}</span>
              <span className="text-xs text-ink-soft ml-2">{new Date(e.at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
